module.exports = [
  'Promise',
  function (Promise) {
    return {
      getPersonalContact: Promise.wrapper('pab:getContacts'),
      deleteContacts: Promise.wrapper('pab:deleteContacts')
    }
  }
]



// WEBPACK FOOTER //
// ./src/js/addressbook/organizational/detail/detailService.js